export default {
    day: '2023-11-14',
    content: {
        mining: [
            {
                unlock: 'miningDepthDweller',
                type: 'context',
                text: '278'
            },
            {
                unlock: 'miningDepthDweller',
                type: 'balance',
                text: '257',
                balance: 'nerf',
                before: '0.008%',
                after: '0.0065%'
            },
            {
                unlock: 'miningDepthDweller',
                type: 'balance',
                text: '277',
                balance: 'buff',
                before: '0.1',
                after: '5'
            }
        ],
        village: [
            {
                type: 'context',
                text: '279'
            },
            {
                type: 'balance',
                text: '280'
            },
            {
                unlock: 'villageCoinUpgrades',
                type: 'balance',
                text: '281'
            },
            {
                unlock: 'villageUpgradeBasics',
                type: 'balance',
                text: '282',
                balance: 'buff',
                before: '15',
                after: '20'
            },
            {
                unlock: 'villageUpgradeBasics',
                type: 'balance',
                text: '283'
            },
            {
                unlock: 'villageOffering1',
                type: 'change',
                text: '284'
            },
            {
                unlock: 'villageOffering1',
                type: 'new',
                text: '285'
            },
            {
                unlock: 'villageOffering4',
                type: 'balance',
                text: '297'
            },
            {
                unlock: 'villageBuildings5',
                type: 'balance',
                text: '286'
            },
            {
                unlock: 'villageBuildings6',
                type: 'balance',
                text: '287'
            },
            {
                unlock: 'villageBuildings7',
                type: 'balance',
                text: '288'
            },
            {
                unlock: 'villageBuildings6',
                type: 'balance',
                text: '289',
                balance: 'nerf',
                before: '+50%',
                after: '+20%'
            },
            {
                type: 'bugfix',
                text: '290'
            },
            {
                unlock: 'villageCoinUpgrades',
                type: 'bugfix',
                text: '291'
            },
            {
                type: 'balance',
                text: '296',
                balance: 'buff',
                before: '25%',
                after: '40%'
            },
            {
                unlock: 'achievementFeature',
                type: 'balance',
                text: '299'
            }
        ],
        achievement: [
            {
                unlock: 'relicFeature',
                type: 'accessibility',
                text: '298'
            }
        ],
        horde: [
            {
                unlock: 'hordeItemMastery',
                type: 'balance',
                text: '295'
            }
        ],
        farm: [
            {
                type: 'balance',
                text: '292'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '271',
                balance: 'buff',
                before: '+10%',
                after: '+50%'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '293',
                balance: 'nerf',
                before: '+250%',
                after: '+150%'
            },
            {
                unlock: 'farmFertilizer',
                type: 'balance',
                text: '294'
            },
            {
                unlock: 'farmDisableEarlyGame',
                type: 'balance',
                text: '215',
                balance: 'buff',
                before: '0.4%',
                after: '0.8%'
            }
        ]
    }
}
